import styled from "styled-components";

export const HeaderNavbarContainerDefaultBox = styled.nav`
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  background: ${props => props.theme.colors.backgroundDark};
  z-index: 105;

  padding: 0.5rem 2rem;
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding: 0.5rem 1rem;
    border-bottom: 1px solid ${props => props.theme.colors.brandPrimary};
  }
`;
